import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";

const GLOBAL_AUDIENCE_FLOORS_TOS = [10, 15, 20, 30, 40, 60];

const GlobalAudienceFloorsTable = ({ isCPC, floorData, isRecalculate }) => {
  return (
    <>
      <TableHead>
        <TableRow>
          <TableCell
            colSpan={
              Object.keys(floorData).length || GLOBAL_AUDIENCE_FLOORS_TOS.length
            }
            align="left"
            style={{
              backgroundColor:
                floorData && Object.keys(floorData).length > 0
                  ? "rgba(163, 191, 253, 1)"
                  : "#e0e0e0",
            }}
          >
            {isCPC ? "CPC Floors" : "Reserve Costs"}
          </TableCell>
        </TableRow>
        <TableRow>
          {floorData && Object.keys(floorData).length > 0
            ? Object.keys(floorData).map((key) => {
                if (isNaN(key)) return null; // Skip if key is not a number
                return <TableCell key={key}>{`${key}s`}</TableCell>;
              })
            : GLOBAL_AUDIENCE_FLOORS_TOS.map((key) => (
                <TableCell key={key}>{`${key}s`}</TableCell>
              ))}
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          {floorData && Object.keys(floorData).length > 0
            ? Object.keys(floorData).map((key) => {
                if (isNaN(key)) return null;
                return (
                  <TableCell
                    key={key}
                    sx={{
                      color: isRecalculate ? "rgba(25, 118, 210, 1)" : "black",
                    }}
                  >{`$${floorData[key]}`}</TableCell>
                );
              })
            : GLOBAL_AUDIENCE_FLOORS_TOS.map((key) => {
                return <TableCell key={key}>&nbsp;</TableCell>;
              })}
        </TableRow>
      </TableBody>
    </>
  );
};

export default GlobalAudienceFloorsTable;
